import { BrowserRouter } from 'react-router'

import { AppProviders } from '@/app/providers'
import { AppRouter } from '@/app/router'
import { RootErrorBoundary } from '@/app/error-boundary'

export function Root(): React.ReactElement {
  return (
    <RootErrorBoundary>
      <BrowserRouter>
        <AppProviders>
          <AppRouter />
        </AppProviders>
      </BrowserRouter>
    </RootErrorBoundary>
  )
}
